import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { topicFeedFetch, topicRelatedListFetch } from '../../../actions/index';
import { translate } from 'react-i18next';
import cx from '../../../styles';
import BaseLayout from '../../../components/Layout/BaseLayout';
import AdCoreSlot from '../../../components/Ads/AdCoreSlot';
import FeedContainer from '../../Feed';
import TopicDescriptionComponent from '../../../components/Topic/TopicDescription';
import TopicRelatedListSidebar from '../../../components/Layout/Sidebars/TopicList';
import Breadcrumbs from '../../../components/Layout/Breadcrumbs';
import Template404Container from '../../404';
import Loader from '../../../components/Common/Loader';
import { Icon } from '../../../components/Common/Icon';
import {getUrlParameter} from '@tickled-media/web-components.tm-helpers';
import { makeRoute } from '../../../helpers';

class TopicViewContainer extends Component {

    constructor(props) {
        super(props);
        this.state = { filter: 'latest', isDataEmpty: false, isLoading: false, showDropdown: false };
    }

    componentDidMount() {
        if (this.props.feedReducer.ifServerFilled && this.props.feedReducer.topic && !(this.props.topicReducer.topicRelatedList && this.props.topicReducer.topicRelatedList.length > 0)) {
            this.props.topicRelatedListFetch(this.props.feedReducer.topic.id);
        }
        //to prevent dynamic feed
        if (this.props.feedReducer.accessedFrom === this.props.location.pathname) return false;
        //on mount
        const slug = this.props.match.params.slug;
        const page = getUrlParameter('page') ? parseInt(getUrlParameter('page')) : 1;
        // const hasTopic = this.props.feedReducer && this.props.feedReducer.topic
        // const isSameSlug= hasTopic && this.props.feedReducer.topic.slug !== slug
        // const hasFeedList = this.props.feedReducer.feedList && this.props.feedReducer.feedList.length
        // if (!hasTopic || isSameSlug || !hasFeedList) {
            this.setState({isLoading: true});
            this.props.topicFeedFetch('latest', page, slug, null, true, this.props.location.pathname)
                .then((response) => {
                    this.setState({isLoading: false});
                    if(response && this.props.feedReducer.topic){
                        this.props.topicRelatedListFetch(this.props.feedReducer.topic.id);
                    }
                    else{
                        this.setState({
                            isDataEmpty: true
                        });
                    }
                });
        // }
        //scroll fix
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.location.pathname !== this.props.location.pathname)) {
            this.setState({isLoading: true});
            this.props.topicFeedFetch('latest', getUrlParameter('page')? parseInt(getUrlParameter('page')) : 1, nextProps.match.params.slug, null, true, this.props.location.pathname)
            .then((response) => {
                this.setState({isLoading: false});
                if(!response){
                    this.setState({
                        isDataEmpty: true
                    });
                }
            });
        }
    }

    buildRightSidebar = () => {
        const ads = this.props.configReducer.ads;
        const rc = [
            this.props.topicReducer.topicRelatedList.length > 0 &&
            <div className={cx("shadow-card")}>
                <TopicRelatedListSidebar
                    topics={this.props.topicReducer.topicRelatedList}
                    appReducer = {this.props.appReducer}
                    match={this.props.match} />
            </div>,
            ads.networkId &&
            <div className={cx("shadow-card")}>
                <AdCoreSlot networkId={ads.networkId} 
                    adUnit={ads.common.half_page.unit}
                    styleClass={ads.common.half_page.styleClass}
                    size={[ads.common.half_page.w, ads.common.half_page.h]}
                    id={ads.common.half_page.id}/>
            </div>
        ];

        return rc;
    }

    filterFeed = (type) => {
        /*const feedFilterType = type === 'feed' ? 'newsfeed' : type;*/
        this.setState({ filter: type, isLoading: true, showDropdown: false });
        this.props.topicFeedFetch(type, getUrlParameter('page') ? parseInt(getUrlParameter('page')) : 1, this.props.match.params.slug, null, true, this.props.location.pathname)
        .then(() => {
            this.setState({isLoading: false});
        });
    }

    toggleShowDropdown = (value) => {
        this.setState({showDropdown: value})
    }

    render() {
        const {t, history, match, landingUrl, serverReqCookie, feedReducer, appReducer} = this.props;
        const lc = [], rc = this.buildRightSidebar();
        const selectedFilter = {
            'latest': t('community_tab_latest'),
            'popular': t('community_tab_trending')
        }

        if(this.state.isDataEmpty){
            return (
                <Template404Container history={history} match={match} />
            );
        }
        else{
            return (
                <BaseLayout 
                    history={history} 
                    match={match}
                    landingUrl={landingUrl}
                    serverReqCookie={serverReqCookie}
                    className={cx("topic-view-container")} 
                    leftCards={lc} rightCards={rc} 
                >
                    <div className={cx("shadow-card", 'no-pad')}>
                        {feedReducer.topic && <TopicDescriptionComponent match={match} topic={feedReducer.topic} />}
                    </div>

                    <div className={cx("normal-card", "no-pad", "bg-transp", "feeds-wrap")}>
                        <div className={cx("flex", "flex-full-width", "flex-center")}>
                            <div className={cx("left")}>{t('menu_feed')}</div>
                            <div className={cx("right", "dropdown")}>
                                {/*<span>{t('topic_filter_by')}</span>
                                <span className={cx("pointer-click", this.state.filter === 'latest' && 'active')} onClick={() => this.filterFeed('latest')}>{t('community_tab_latest')}</span>
                                <span>/</span>
                                <span className={cx("pointer-click", this.state.filter === 'popular' && 'active')} onClick={() => this.filterFeed('popular')}>{t('community_tab_trending')}</span>*/}
                                
                                <button className={cx("dropbtn")} onClick={() => this.toggleShowDropdown(!this.state.showDropdown)}>
                                    {selectedFilter[this.state.filter]}
                                    <Icon name="dropdown-icon" className="feed-filter-arrow" />
                                </button>
                                <div className={cx("dropdown-content", this.state.showDropdown ? 'show' : '')}>
                                    <a 
                                        href={makeRoute(`/feed/latest`, appReducer)} 
                                        onClick={(e) => { e.preventDefault(); this.filterFeed('latest');}}
                                    >
                                        {t('community_tab_latest')}
                                    </a>
                                    <a 
                                        href={makeRoute(`/feed/popular`,appReducer)} 
                                        onClick={(e) => { e.preventDefault(); this.filterFeed('popular');}}
                                    >
                                        {t('community_tab_trending')}
                                    </a>
                                </div>
                                <div className={cx("dropdown-content-wrapper", this.state.showDropdown ? 'show' : '')} id="dropdown-content-wrapper" onClick={(e) => {if(e.target == document.getElementById('dropdown-content-wrapper')) this.toggleShowDropdown(false)}}></div>
                            </div>
                        </div>
                    </div>

                    { feedReducer.topic && <FeedContainer {...this.props} subType="topic" /> }

                    { this.state.isLoading && <Loader /> }

                    <Breadcrumbs links={[
                        { location: '/feed', label: 'Home' },
                        { location: '/topics', label: 'Topics' },
                        { location: `/topic/${match.params.slug}`, label: feedReducer.topic && feedReducer.topic.name }
                    ]} />

                </BaseLayout>
            );
        }
    }
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        topicFeedFetch,
        topicRelatedListFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TopicViewContainer));
